import { useEffect } from "react";

function ActingHome() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="actingHome">
        </div>
    );
};

export default ActingHome;
